import { render, staticRenderFns } from "./context-quick-tags.vue?vue&type=template&id=784277cb"
import script from "./context-quick-tags.vue?vue&type=script&lang=js"
export * from "./context-quick-tags.vue?vue&type=script&lang=js"
import style0 from "./context-quick-tags.vue?vue&type=style&index=0&id=784277cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports